import TotalsConstant from '../../../constant/checkout/quote/TotalsConstant';
import {Observable} from "rxjs";

/**
 * Receive action type(PLACE_ORDER_AFTER | CREATE_CREDITMEMO_AFTER) and request
 * @param action$
 */
export default (action$) => {
    return action$.ofType(TotalsConstant.SALES_QUOTE_COLLECT_TOTALS_BEFORE)
        .mergeMap(action => {
            let quote = action.quote;
            if(quote) {
                delete quote.base_gift_voucher_discount;
                delete quote.gift_voucher_discount;
                delete quote.magespacex_base_discount;
                delete quote.magespacex_discount;
                delete quote.gift_voucher_gift_codes;
                delete quote.gift_voucher_gift_codes_discount;
                delete quote.codes_base_discount;
                delete quote.codes_discount;
                delete quote.base_giftvoucher_discount_for_shipping;
                delete quote.giftvoucher_discount_for_shipping;
                delete quote.magespacex_base_discount_for_shipping;
                delete quote.magespacex_discount_for_shipping;
                delete quote.giftcodes_applied_discount_for_shipping;

                if (quote.addresses && Array.isArray(quote.addresses) && quote.addresses.length) {
                    quote.addresses.forEach(address => {
                        address.base_gift_voucher_discount = 0;
                        address.gift_voucher_discount = 0;
                        address.base_giftvoucher_discount_for_shipping = 0;
                        address.giftvoucher_discount_for_shipping = 0;
                        address.magespacex_base_discount = 0;
                        address.magespacex_discount = 0;
                        address.magespacex_base_discount_for_shipping = 0;
                        address.magespacex_discount_for_shipping = 0;
                        address.giftcodes_applied_discount_for_shipping = null;
                    })
                }
                if (quote.items && Array.isArray(quote.items) && quote.items.length) {
                    quote.items.forEach(item => {
                        item.base_gift_voucher_discount = 0;
                        item.gift_voucher_discount = 0;
                        item.magespacex_base_discount = 0;
                        item.magespacex_discount = 0;
                        item.giftcodes_applied = null;
                    })
                }
            }
            return Observable.empty();
        });
}



// WEBPACK FOOTER //
// ./src/view/epic/observer/giftcard/GiftcardSalesQuoteCollectTotalBeforeEpic.js